import { useEffect, useMemo, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { useSurfLibrary } from "../hooks/useSurfLibrary";
import { SpeakerReader } from "../components/reader/SpeakerReader";
import { surfDeckAssetFingerprint } from "../utils/surfDeckAssets";

export function SpeakerReaderPage() {
  const { deckId } = useParams<{ deckId: string }>();
  const { getDeck, refresh, status } = useSurfLibrary();

  const row = deckId ? getDeck(deckId) : undefined;
  const deck = row?.deck;

  const assetFingerprint = useMemo(
    () => (deck ? surfDeckAssetFingerprint(deck) : ""),
    [deck],
  );
  const stableDeck = useMemo(
    () => deck,
    [assetFingerprint, deck?.contentUpdatedAt],
  );

  const refreshedForRef = useRef<string | null>(null);
  useEffect(() => {
    if (!deckId || !navigator.onLine) return;
    if (refreshedForRef.current === deckId) return;
    refreshedForRef.current = deckId;
    void refresh().catch(() => undefined);
  }, [deckId, refresh]);

  if (!deckId) {
    return (
      <div className="speaker-reader-page-empty">
        <p>Deck non specificato.</p>
        <Link to="/">← Libreria</Link>
      </div>
    );
  }

  if (!stableDeck) {
    return (
      <div className="speaker-reader-page-empty">
        <p>
          {navigator.onLine
            ? "Deck in caricamento…"
            : "Deck non disponibile offline. Apri il lettore almeno una volta con connessione."}
        </p>
        <p className="muted">Sync: {status}</p>
        <Link to="/">← Libreria</Link>
        {!navigator.onLine && deckId && (
          <Link to={`/deck/${deckId}`}>Apri editor (se in cache)</Link>
        )}
      </div>
    );
  }

  if (!stableDeck.slides.length) {
    return (
      <div className="speaker-reader-page-empty">
        <h1>{stableDeck.title}</h1>
        <p className="muted">Nessuna slide nel deck.</p>
        <Link to={`/deck/${deckId}/wizard`}>Completa il wizard</Link>
      </div>
    );
  }

  return <SpeakerReader deck={stableDeck} documentId={deckId} />;
}
